import type { HoleRequest, ToolChangeInfo } from '@/types/predict.types';
import { apiClient } from './client';

export const predictApi = {
  /** POST /predict/tools — returns ordered tool sequence for a given hole. */
  getToolsForHole: async (request: HoleRequest): Promise<ToolChangeInfo[]> => {
    const { data } = await apiClient.post<ToolChangeInfo[]>('/predict/tools', request);
    return data;
  },
};
